import dayjs from "dayjs"
import BaseModal from "../../../../components/layout/BaseModal"
import { BillCreditGet } from "../../../../data/Types"
import BaseInputArea from "../../../../components/elements/BaseInputArea"
import BaseInputField from "../../../../components/elements/BaseInputField"
import { DownloadIcon } from "lucide-react"
import { useDownloadDocumentMutation } from "../../../api/services"
import { formatCurrency } from "../../../../services/functions"

type CreditDetailModalType = {
    modalId: number
} & BillCreditGet

export default function CreditDetailModal(props: CreditDetailModalType) {
    // download file - credit document
    const { mutate: downloadFile } = useDownloadDocumentMutation()
    const handleDownload = () => {
        if (props.s3DocumentRef?.s3Key) {
            downloadFile({
                id: props._id,
                s3Key: props.s3DocumentRef.s3Key,
                filetype: "credit",
                filename: props.s3DocumentRef.title || "Gutschrift.pdf",
            })
        }
    }

    console.log(props)
    return (
        <BaseModal
            title="Gutschrift"
            size
            modalId={props.modalId}
            bottomRow={
                <div className="flex justify-end gap-2">
                    <button onClick={handleDownload} disabled={!props.s3DocumentRef?.s3Key} className="btn btn-primary">
                        Gutschrift herunterladen
                        <DownloadIcon className="w-4 h-4" />
                    </button>
                </div>
            }>
            <div className="flex flex-col gap-4 pt-2 md:min-w-[350px]">
                {/* Basic Credit Information */}
                <div className="flex flex-col gap-3">
                    <div className="flex flex-col md:flex-row gap-8 p-4 bg-gray-50 rounded-lg border">
                        <div className="flex flex-col">
                            <span className="text-sm text-gray-500">Betrag</span>
                            <span className="text-lg font-semibold">{formatCurrency(props.amount)}</span>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-sm text-gray-500">Datum</span>
                            <span className="text-lg font-semibold">{dayjs(props.createdAt).format("DD.MM.YYYY")}</span>
                        </div>
                    </div>
                    {props.comment && (
                        <div className="flex flex-col p-4 bg-gray-50 rounded-lg border">
                            <span className="text-sm text-gray-500 mb-1">Kommentar</span>
                            <span className="font-medium break-words whitespace-pre-wrap">{props.comment}</span>
                        </div>
                    )}
                </div>

                {/* Positions Section - Only shown if positions data exists */}
                {props.positions && props.positions.length > 0 && (
                    <div className="flex flex-col gap-3 pt-2 border-t">
                        <div className="text-lg font-semibold">Erstattete Positionen</div>
                        <div className="flex flex-col gap-2">
                            {props.positions.map((position, index) => (
                                <div key={position.position_id || index} className="border rounded-lg p-3 bg-gray-50">
                                    {/* Position Header */}
                                    <div className="flex items-center gap-2 mb-2 pb-2 border-b">
                                        <span className="font-semibold text-sm">Position {position.position_id}</span>
                                        <span className="text-gray-600">•</span>
                                        <span className="text-sm text-red-600 font-medium">
                                            -{position.reducedAmount} {position.unit}
                                        </span>
                                    </div>

                                    {/* Position Details */}
                                    <div className="grid grid-cols-2 gap-2 text-sm">
                                        <div className="col-span-2">
                                            <span className="text-xs text-gray-500">Beschreibung</span>
                                            <p className="font-medium">{position.description}</p>
                                        </div>

                                        <div>
                                            <span className="text-xs text-gray-500">Erstattung Netto</span>
                                            <p className="font-medium">{formatCurrency(position.refundAmountNetto)}</p>
                                        </div>

                                        <div>
                                            <span className="text-xs text-gray-500">Erstattung Brutto</span>
                                            <p className="font-medium">{formatCurrency(position.refundAmountBrutto)}</p>
                                        </div>

                                        <div>
                                            <span className="text-xs text-gray-500">Steuersatz</span>
                                            <p className="font-medium">{position.tax}%</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </BaseModal>
    )
}
